<!--
 * Path: src/core/components/dialogs/InfoDialog.vue
 * Task: Displays application metadata, version history, and status, fully conforming to responsive light/dark theme constraints.
-->
<template>
  <BaseDialog
    v-model="authStore.isInfoDialogOpen"
    title="About Unravel"
    max-width="500"
    @close="authStore.isInfoDialogOpen = false"
  >
    <v-card variant="text" class="text-center pa-4 bg-transparent">
      <!-- Logo inside a circular avatar with a white border, matching the home and menubar style -->
      <v-avatar size="96" color="white" style="border: 1px solid white;" class="mb-4 elevation-2">
        <v-img :src="logoUrl" alt="Unravel Logo"></v-img>
      </v-avatar>
      <h2 class="text-h3 text-high-emphasis mb-6">Unravel</h2>
      <div class="text-subtitle-1 text-medium-emphasis mb-6">Modeling agile collaboration processes</div>

      <v-row justify="center">
        <v-col cols="12">
          <v-table density="comfortable" class="border rounded-lg overflow-hidden bg-surface text-high-emphasis">
            <tbody>
            <tr>
              <td class="text-left text-medium-emphasis">Application Version</td>
              <td class="text-right text-mono font-weight-bold">{{ authStore.appData?.version || '0.11.0' }}</td>
            </tr>
            <tr>
              <td class="text-left text-medium-emphasis">Status</td>
              <td class="text-right text-success d-flex align-center justify-end font-weight-bold">
                <v-icon size="x-small" color="success" class="me-1">mdi-circle</v-icon>
                Operational
              </td>
            </tr>
            <tr>
              <td class="text-left text-medium-emphasis">Contact</td>
              <td class="text-right d-flex align-center justify-end text-mono">
                lars.streich@digits.schwarz
              </td>
            </tr>
            </tbody>
          </v-table>
        </v-col>
      </v-row>
    </v-card>
  </BaseDialog>
</template>

<script setup lang="ts">
/**
 * Path: src/core/components/dialogs/InfoDialog.vue
 * Task: Setup layout configurations for the Unravel description window.
 */
import { useAuthStore } from '@/store/auth';
import BaseDialog from './BaseDialog.vue';
import logoUrl from '@/assets/unravel-logo-label-128.png';

const authStore = useAuthStore();
</script>

<style scoped>
.text-mono {
  font-family: monospace;
}
</style>
